import { Button, Col, Form, Row } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { FormTextInput } from '../../../shared/components/crmFormElement/FormInput';
import { GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import { mergeDemergeClaims } from '../../../store/actions/newAdmissionAction';
import { centeredNotification } from '../../../utils/utility';

const MergeDeMergeClaimsConfigurator: React.FC = (): any => {
  const [mergeForm] = Form.useForm();
  const [deMergeForm] = Form.useForm();
  const dispatch = useDispatch();
  const [isMergeloading, setIsMergeloading] = React.useState(false);
  const [isDemergeLoading, setIsDemergeLoading] = React.useState(false);

  const onMergeOrDeMerge = async (event: any): Promise<void> => {
    const action: string = event.currentTarget.getAttribute('data-action');
    if (action === 'merge') {
      setIsMergeloading(true);
    } else {
      setIsDemergeLoading(true);
    }
    const formInstance = action === 'merge' ? mergeForm : deMergeForm;
    await formInstance?.validateFields().then((): any => {
      const oldHospactionId: string = (action === 'merge' ? formInstance.getFieldsValue()?.['oldHospactionId'] || '' :
        formInstance.getFieldsValue()?.['oldHospactionId_deMerge'] || '')?.replace(/\s+/g, '');
      const newHospactionId: string = (action === 'merge' ? formInstance.getFieldsValue()?.['newHospactionId'] || '' :
        formInstance.getFieldsValue()?.['newHospactionId_deMerge'] || '')?.replace(/\s+/g, '');
      if (oldHospactionId && newHospactionId) {
        const mergeClaimsPayload = {
          action,
          oldHospactionId,
          newHospactionId,
        };
        dispatch(mergeDemergeClaims(mergeClaimsPayload, (res: any): any => {
          centeredNotification(res, 'success');
          if (action === 'merge') {
            setIsMergeloading(false);
            mergeForm?.resetFields();
          } else {
            setIsDemergeLoading(false);
            deMergeForm?.resetFields();
          }
        }, (res: any): any => {
          centeredNotification(res);
          if (action === 'merge') {
            setIsMergeloading(false);
            mergeForm?.resetFields();
          } else {
            setIsDemergeLoading(false);
            deMergeForm?.resetFields();
          }
        }));
      }
    }).catch((error: any): any => {
      setIsMergeloading(false);
      setIsDemergeLoading(false);
    });
  };

  return (
    <React.Fragment>
      <div>
        <Form form={mergeForm} className="flex-element flex-col gap-5">
          <Row gutter={GUTTOR_SPACE} className={'PayerEmailConfiguration'}>
            <Col className="m-10 font-12 font-weight-text">
              <div><b>Merge Claims</b></div>
            </Col>
          </Row>
          <Row gutter={GUTTOR_SPACE} className="flex flex-row align-baseline">
            <Col md={6}>
              <FormTextInput detail={{
                key: 'oldHospactionId',
                placeholder: 'Enter Old Hospaction Id',
                hideLabel: true,
                required: true,
                rules: [{ required: true, message: 'Old Hospaction Id is required!' }],
              }} />
            </Col>
            <Col md={6}>
              <FormTextInput detail={{
                key: 'newHospactionId',
                placeholder: 'Enter New Hospaction Id',
                hideLabel: true,
                required: true,
                rules: [{ required: true, message: 'New Hospaction Id is required!' }],
              }} />
            </Col>
            <Col md={1}>
              <Button type="primary" data-action="merge" onClick={(e: any): any => onMergeOrDeMerge(e)}
                loading={isMergeloading} disabled={isMergeloading}>
                Merge
              </Button>
            </Col>
          </Row>
        </Form>
        <Form form={deMergeForm} className="flex-element flex-col gap-5">
          <Row gutter={GUTTOR_SPACE} className={'PayerEmailConfiguration'}>
            <Col className="m-10 font-12 font-weight-text">
              <div><b>De-Merge Claims</b></div>
            </Col>
          </Row>
          <Row gutter={GUTTOR_SPACE} className="flex flex-row align-baseline">
            <Col md={6}>
              <FormTextInput detail={{
                key: 'oldHospactionId_deMerge',
                placeholder: 'Enter Old Hospaction Id',
                hideLabel: true,
                required: true,
                rules: [{ required: true, message: 'Old Hospaction Id is required!' }],
              }} />
            </Col>
            <Col md={6}>
              <FormTextInput detail={{
                key: 'newHospactionId_deMerge',
                placeholder: 'Enter New Hospaction Id',
                hideLabel: true,
                required: true,
                rules: [{ required: true, message: 'New Hospaction Id is required!' }],
              }} />
            </Col>
            <Col md={2}>
              <Button type="primary" onClick={(e: any): any => onMergeOrDeMerge(e)} data-action="de-merge"
                loading={isDemergeLoading} disabled={isDemergeLoading}>
                De Merge
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </React.Fragment>
  );
};
export default MergeDeMergeClaimsConfigurator;
